<script setup>
import { reactive, onMounted, computed } from 'vue';
import { getPatient, createPatient, editPatient } from '../firebase_files/patient_functions';
import { getScheduleByID } from '../firebase_files/schedule';

import { chronicDiseases, resetDiseaseObjects } from '@/libraries/DiseaseObjects'
import { convertDatetoYMD } from '@/libraries/DateFunctions'

const emits = defineEmits(['cancel', 'setPatient']);
const props = defineProps(['existingPatient', 'clinicPatientCr', 'aptId'])
const state = reactive({
    patient: { cr: '' },
    mode: 'find',
    patientHasDisease: false,
    existingPatient: false,
})

/**
 * @returns {string} selected diseases in display friendly format i.e => "AIDS, Dementia"
 */
const displayDisease = computed(() => {
    const selectedDiseases = chronicDiseases.filter((opt) => opt.isSelected)
    const names = [];
    selectedDiseases.forEach(opt => {
        names.push(opt.name)
    })
    return names.join(', ')
})


isExistingPatient();
handleClinicPatient();
resetDiseaseObjects(); // make sure diseases are reset

/**
 * Handle patient from clinic
 * Assumes only CR/ID is provided
 */
async function handleClinicPatient() {
    if (props.clinicPatientCr) {
        state.patient.cr = props.clinicPatientCr;
        const patient = await getPatient(state.patient.cr);

        if (patient) {
            submitPatient(patient);
        } else{
          state.mode = 'add';
          // get scehedul from backend
          const scheduleData = await getScheduleByID(props.aptId);
          
          // update relative properties
          state.patient.name = scheduleData.name;
          state.patient.dateOfBirth = convertDatetoYMD(scheduleData.dateOfBirth);

        }
        
    }
}

function isExistingPatient() { // for editing patient
    try {
        const patient = props.existingPatient;
        if (patient) {
            state.patient = patient;
            state.mode = 'add';
            state.existingPatient = true;
        } else return false;
    } catch (err) {
        return false;
    }
}

async function lookupPatient() {
    let patient = await getPatient(state.patient.cr);
    if (patient) {
        submitPatient(patient);
    } else {
        state.mode = 'add';
        setTimeout(() => {
            document.querySelector('#patient-name').focus();
        });
    }
}

onMounted(() => {
    document.querySelector('#patient-cr-code').focus();
})


function onEnterKey() {
    if (state.mode == 'find') {
        lookupPatient();
    } else {
        addPatient();
    }
}

async function addPatient() { // need to add edit patient here
    // if(!checkPatient(patient.value)){ needs to be updated at somepoint
    //     return
    // }
    // DISABLED FOR TESTING, SHOULD BE ENABLED IN PROD
    state.patient.diseases = chronicDiseases.filter((opt) => opt.isSelected)
    if (state.existingPatient) {
        await editPatient(state.patient);
        submitPatient(state.patient);
        return;
    }
    else {
        const newId = await createPatient(state.patient);
        submitPatient(state.patient);
    }
}


function submitPatient(patient) {
    emits('setPatient', patient)
}

function cancel() {
    emits('cancel')
}

function toggle(option) {
    option.isSelected = !option.isSelected;
}



</script>
<template>
    <div class="modal">
        <div class="modal-content" v-on:keyup.enter="onEnterKey">

            <div class="modal-top">
                <div class="title">
                    <span v-if="state.mode == 'add' && state.existingPatient">Edit Patient</span>
                    <span v-else-if="state.mode == 'find'">Find Patient</span>
                    <span v-else-if="state.mode == 'add'">New Patient</span>
                </div>
                <div class="close" @click="cancel()">
                    <i class="fa fa-times"></i>
                </div>
            </div>

            <div class="form-item">
                <label>Patient ID</label>
                <input v-model="state.patient.cr" id="patient-cr-code">
            </div>
            <!-- <button @click="cancel()" style="margin-left: 10px;">Cancel</button> -->
            <div v-if="state.mode == 'add'">

                <div class="form-item">
                    <label>Full Name</label>
                    <input v-model="state.patient.name" id="patient-name">
                </div>
                <div class="form-item">
                    <label>Date of Birth</label>
                    <input type="date" v-model="state.patient.dateOfBirth">
                </div>
                <div class="form-item">
                    <label>DISEASE/COMORBIDITY?</label>
                    <input v-model="state.patientHasDisease" type="checkbox">
                </div>
                <div id="disease-selection" v-if="state.patientHasDisease">
                    <div class="form-item"><label>Disease Selection</label>
                        <div>{{ displayDisease }}</div>
                    </div>
                    <div id="disease-list">
                        <div v-for="(opt) in chronicDiseases" :key="opt" @click="toggle(opt)"
                            :class="{ selected: opt.isSelected }">
                            {{ opt.name }}
                        </div>
                    </div>
                </div>


                <!-- <PatientRegistrationVue :patientCR="state.patientCr" @done="submitPatient"></PatientRegistrationVue> -->
            </div>

            <div class="buttons" v-if="state.mode == 'find'">
                <div class="left">
                    <button @click="state.mode = 'add'" class="alt">New Patient</button>
                </div>
                <div class="right">
                    <button @click="lookupPatient()" v-if="state.mode == 'find'" class="primary">
                        <i class="fa fa-search"></i> Search
                    </button>
                </div>
            </div>

            <div class="buttons" v-if="state.mode == 'add'">
                <div class="left">
                    <button @click="state.mode = 'find'" class="alt">Search</button>
                </div>
                <div class="right">
                    <button @click="addPatient()" class="primary">
                        <i class="fa fa-plus"></i> Patient
                    </button>
                </div>
            </div>


        </div>
    </div>
</template>
<style scoped lang="scss">
.modal-content {
    width: 46.5rem;
}

.my-form-item {
    display: flex;

    label {
        padding-top: 10px;
    }

    input {
        flex: 1;
        margin: 0 15px;
    }
}


#disease-selection {

    #disease-list {
        max-height: 250px;
        overflow-y: scroll;
    }


    label {
        margin-left: auto;
        margin-right: auto;
    }

    .selected {
        background-color: aqua;
    }

}

div.buttons {
    display: flex;

    .left {
        flex: 1;
    }
}
</style>